import { buildFacilitiesMapLayer } from "@lib/logic";
import { getAllMeetingRoomSuggestionsUnfilteredForRequest, useAppSelector } from "@lib/store";
import { useRequiredContext } from "@lib/utils";

import { useRoomsRequest } from "../rooms/useRoomsRequest";
import { HaNContext } from "../shell/HaNContext";
import { HaNMapStageContext, useHaNMapLayer } from "../shell/regions/HaNMapStageContext";
import { useFacilitiesModel } from "./useFacilitiesModel";

export const FacilitiesMap = () => {
  const { tab } = useRequiredContext(HaNContext);
  const { floorId } = useRequiredContext(HaNMapStageContext);

  if (tab !== "facilities" || !floorId) return null;

  return <FacilitiesMapLayer floorId={floorId} />;
};

type FacilitiesMapLayerProps = {
  floorId: string;
};

// Builds the tab's layer for the page's one map, which the map stage draws. The rooms and areas are the ones their
// details look up, so each marker opens them.
const FacilitiesMapLayer = ({ floorId }: FacilitiesMapLayerProps) => {
  const { facilities, filterData, showsRooms, showsAreas } = useRequiredContext(HaNContext);
  const { highlightedIds } = useFacilitiesModel();
  const request = useRoomsRequest();
  const rooms = useAppSelector(state => getAllMeetingRoomSuggestionsUnfilteredForRequest(state, request));

  const layer = buildFacilitiesMapLayer({
    floorId,
    facilities,
    rooms: showsRooms ? rooms : [],
    areas: showsAreas ? filterData.workspaces.allData : [],
    highlightedIds,
  });

  useHaNMapLayer(layer);

  return null;
};
